import { CXContainerableBlock } from '~/components/ClientExperience/OneFlow/models/cx-containerable-block.model';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import type { FlowRevision } from '~/models/flow-revision.model';
import { IChargeContainerBlockResponse } from '~/types/server.types';
import { CXChargeBlock } from '~/components/ClientExperience/OneFlow/models/cx-charge-block.model';

export class CXChargeContainerBlock extends CXContainerableBlock {
    type: 'charge_container_block';

    constructor(
        block: IChargeContainerBlockResponse,
        flowRevision: FlowRevision<CXRootStore>,
        rootStore: CXRootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
    }

    get displayName() {
        return 'online payment';
    }

    get chargeBlock(): CXChargeBlock {
        return this.childBlocks[0] as CXChargeBlock;
    }
}
